import React from 'react';
import ReactDOM from 'react-dom/client';

import PodcastList from './components/PodcastList';

const podcastListEn = document.getElementById('podcast-list-en');
if (podcastListEn !== null) {
  const selectDiv = ReactDOM.createRoot(podcastListEn);
  selectDiv.render(
    <>
      <PodcastList language="en" />
    </>
  );  
}


const podcastListEs = document.getElementById('podcast-list-es');
if (podcastListEs !== null) {
  const selectDiv = ReactDOM.createRoot(podcastListEs);
  selectDiv.render(
    <>
      <PodcastList language="es" />
    </>
  );  
}


const podcastListPt = document.getElementById('podcast-list-pt');
if (podcastListPt !== null) {
  const selectDiv = ReactDOM.createRoot(podcastListPt);
  selectDiv.render(
    <>
      <PodcastList language="pt" />
    </>
  );  
}